<template>
  <section class="newsletter">
      <h2>{{ data.headline }}</h2>
      <div class="wysiwyg" v-html="data.copy"></div>
      <div class="wysiwyg" v-html="data.list"></div>

      <!-- Begin Mailchimp Signup Form -->
      <link href="//cdn-images.mailchimp.com/embedcode/classic-071822.css" rel="stylesheet" type="text/css">
      <div id="mc_embed_signup">
        <form action="https://bigmedium.us8.list-manage.com/subscribe/post?u=1ffc5dc90f6418a5c93f380d8&amp;id=91cb7ae2b3&amp;f_id=00dac4e1f0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
          <div id="mc_embed_signup_scroll">
            <input type="email" placeholder="Email Address" value="" name="EMAIL" class="required email" id="mce-EMAIL">
            <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_1ffc5dc90f6418a5c93f380d8_91cb7ae2b3" tabindex="-1" value=""></div>
            <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button">
          </div>
        </form>
      </div>
      <!--End mc_embed_signup-->

  </section>
</template>

<script>
export default {
  props: ['data'],
};
</script>

<style scoped lang="less">
@import '../css/variables';

.newsletter {
  margin-bottom: 40px;
  padding: 60px 40px;
  text-align: center;
  color: #000;
  background-color: @themeColor1;
  @media (max-width: @mobile) {
    padding: 60px 20px;
  }
  h2 {
    margin-bottom: 30px;
  }
  .btn {
    margin-bottom: 40px;
  }
}
</style>

<style lang="less">
@import '../css/variables';

.newsletter {
  #mc_embed_signup {
    display: flex;
    justify-content: center;
    form {
      width: 100%;
      padding: 0;
      #mc_embed_signup_scroll {
        display: flex;
        justify-content: center;
        gap: 10px;
        input[type="email"] {
          width: 35%;
          height: 60px;
          padding: 0 10px;
          font-size: 18px;
          border: none;
          border-radius: 0;
          @media (max-width: @mobile) {
            width: 60%;
          }
          &:focus {
            outline: 2px solid @themeColor3;
          }
        }
      }
    }
    .button {
      height: 60px;
      padding: 0 50px;
      font-size: 18px;
      font-weight: bold;
      background-color: @themeColor2;
      border-radius: 0;
      @media (max-width: @mobile) {
        padding: 0 20px;
      }
    }
  }

  .wysiwyg {
    p,
    li {
      font-size: 22px;
    }
    ul {
      @media (min-width: @mobile) {
        display: flex;
        justify-content: center;
        gap: 35px;
        list-style: disc;
      }
      li {
        text-align: left;
        font-weight: bold;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Newsletter.vue